function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, fieldset"),
      (element) => {
        if (element.tagName === "SELECT") {
          return element.value;
        }
        if (element.tagName === "FIELDSET") {
          return Array.from(element.querySelectorAll("input")).find(
            (radio) => radio.checked
          )?.value;
        }
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(
        `[data-selected-dropdown-swatch="${name}"] > .swatch`
      );
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset"
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = this.querySelector(
        `[data-selected-swatch-value="${name}"]`
      );
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute("value");
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === "INPUT") {
        element.classList.toggle("disabled", !availableElement);
      } else if (element.tagName === "OPTION") {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace(
              "[value]",
              value
            );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

// customElements.define("product-recommendations", ProductRecommendations);

// // custom js by mandasa
$(document).on("click", ".maintainance-button", function (event) {
  event.preventDefault();
  var selected_id = 48858005733723;
  var ID = $(this).attr("var_id");
  var $button = $(this);
  var $spinner = $button.find(".cart-loading-spinner");
  var $topParent = $button.closest(".upsell_product");
  var productId = $topParent.attr("product_id");
  var $btn_txt_upsell = $topParent.find("#btn_txt_upsell");
   // progress on add to cart click

            const giftids = document.querySelector(".id_here");
            const mediumGiftVariantId = parseInt(giftids?.getAttribute('data_id'), 10) || null;
            const targetGiftVariantId = parseInt(giftids?.getAttribute('data_gift'), 10) || null;
            const main_progress = document.querySelector('.shipping-bar-container');
            
            if (main_progress) {
                function updateProgressBar(subtotal) {
                    let freeShip = parseFloat(document.querySelector(".target-free-ship")?.textContent) || 0;
                    let mediumGift = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
                    let premiumTarget = parseFloat(document.querySelector(".target_amount")?.textContent) || 100;
                    let highestTarget = Math.max(freeShip, mediumGift, premiumTarget);
            
                    let progressBar = document.getElementById("progress-bar");
                    if (progressBar) {
                        let progressPercentage = Math.min((subtotal / highestTarget) * 100, 100);
                        requestAnimationFrame(() => {
                            progressBar.style.transition = "width 1.6s ease-out";
                            progressBar.style.width = progressPercentage + "%";
                        });
                    }
            
                    updateStep(".step1", ".new_hide1", freeShip, subtotal);
                    updateStep(".step2", ".new_hide2", mediumGift, subtotal);
                    updateStep(".step3", ".new_hide3", premiumTarget, subtotal);
                }
            
                function updateStep(stepSelector, hideSelector, target, subtotal) {
                    setTimeout(() => {
                        let step = document.querySelector(stepSelector);
                        let hideElement = document.querySelector(hideSelector);
                        if (step && hideElement) {
                            if (subtotal >= target) {
                                step.classList.add("hide-main");
                                hideElement.classList.add("active");
                                hideElement.style.display = "block";
                            } else {
                                step.classList.remove("hide-main");
                                hideElement.classList.remove("active");
                                hideElement.style.display = "none";
                            }
                        }
                    }, 1000);
                }
            
                function updateShippingMessage(subtotal) {
                    let freeShipTarget = parseFloat(document.querySelector(".target-free-ship")?.textContent) || 0;
                    let mediumGiftTarget = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
                    let targetAmount = parseFloat(document.querySelector(".target_amount")?.textContent) || 0;
            
                    let shippingMessage = document.getElementById("shipping-message");
            
                    if (shippingMessage) {
                        let spans = shippingMessage.querySelectorAll("span:not(.amount-placeholder)");
                        let amounts = shippingMessage.querySelectorAll(".amount-placeholder");
            
                        spans.forEach(span => span.style.display = "none");
            
                      // Convert values to numbers or null if empty
                    let freeShipTargetNum = freeShipTarget ? Number(freeShipTarget) : null;
                    let mediumGiftTargetNum = mediumGiftTarget ? Number(mediumGiftTarget) : null;
                    let targetAmountNum = targetAmount ? Number(targetAmount) : null;
                    
                    console.log("All targets available:", freeShipTargetNum !== null && mediumGiftTargetNum !== null && targetAmountNum !== null);
                    console.log("Medium gift missing:", mediumGiftTargetNum === null && targetAmountNum !== null);
                    console.log("Target amount missing:", targetAmountNum === null && mediumGiftTargetNum !== null);
                              console.log("targetAmountNum" , targetAmountNum);
                    
                    if (freeShipTargetNum !== null && mediumGiftTargetNum !== null && targetAmountNum !== null) {
                        if (subtotal < freeShipTargetNum && spans[0] && amounts[0]) {
                            let remaining = (freeShipTargetNum - subtotal).toFixed(2);
                            spans[0].style.display = "block";
                            amounts[0].textContent = remaining;
                        } else if (subtotal < mediumGiftTargetNum && spans[1] && amounts[1]) {
                            let remaining = (mediumGiftTargetNum - subtotal).toFixed(2);
                            spans[1].style.display = "block";
                            amounts[1].textContent = remaining;
                        } else if (subtotal < targetAmountNum && spans[2] && amounts[2]) {
                            let remaining = (targetAmountNum - subtotal).toFixed(2);
                            spans[2].style.display = "block";
                            amounts[2].textContent = remaining;
                        } else if (spans[3]) {
                            spans[3].style.display = "block";
                        }
                    } else if (mediumGiftTargetNum === null && targetAmountNum !== null) {
                      if (subtotal < freeShipTargetNum && spans[0] && amounts[0]) {
                        console.log("get it");
                            let remaining = (freeShipTargetNum - subtotal).toFixed(2);
                            spans[0].style.display = "block";
                            amounts[0].textContent = remaining;
                        } else if (subtotal < targetAmountNum && spans[1] && amounts[1]) {
                            let remaining = (targetAmountNum - subtotal).toFixed(2);
                            spans[1].style.display = "block";
                            amounts[1].textContent = remaining;
                        } else if (spans[2]) {
                            spans[2].style.display = "block";
                        }
                    } else if (targetAmountNum === null &&  mediumGiftTargetNum !== null) {
                       if (subtotal < freeShipTargetNum && spans[0] && amounts[0]) {
                            let remaining = (freeShipTargetNum - subtotal).toFixed(2);
                            spans[0].style.display = "block";
                            amounts[0].textContent = remaining;
                        } else if (subtotal < mediumGiftTargetNum && spans[1] && amounts[1]) {
                            let remaining = (mediumGiftTargetNum - subtotal).toFixed(2);
                            spans[1].style.display = "block";
                            amounts[1].textContent = remaining;
                        } else if (spans[2]) {
                            spans[2].style.display = "block";
                        }
                    }
            
            
                    }
                }
            
                function handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget) {
                fetch("/cart.js")
                    .then(response => response.json())
                    .then(cart => {
                        const cartItems = cart.items || [];
                        const mediumGiftItem = cartItems.find(item => item.id === mediumGiftVariantId);
                        const targetGiftItem = cartItems.find(item => item.id === targetGiftVariantId);
            
                        if (subtotal >= mediumGiftTarget) {
                            if (!mediumGiftItem) {
                                addGiftToCart(mediumGiftVariantId);
                            } else if (mediumGiftItem.quantity !== 1) {
                                updateGiftQuantity(mediumGiftVariantId, 1);
                            }
                        } else if (mediumGiftItem) {
                            removeGiftFromCart(mediumGiftVariantId);
                        }
            
                        if (subtotal >= premiumTarget) {
                            if (!targetGiftItem) {
                                addGiftToCart(targetGiftVariantId);
                            } else if (targetGiftItem.quantity !== 1) {
                                updateGiftQuantity(targetGiftVariantId, 1);
                            }
                        } else if (targetGiftItem) {
                            removeGiftFromCart(targetGiftVariantId);
                        }
                    })
                    .catch(error => console.error("Error fetching cart:", error));
            }
            
                function addGiftToCart(variantId) {
                    fetch("/cart/add.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id: variantId, quantity: 1 }),
                    })
                        .then(response => response.json())
                        .then(data => {
                            console.log("Added gift to cart:", data);
                            updateCartDrawer();
                        })
                        .catch(error => console.error("Error adding gift to cart:", error));
                }
            
                function updateGiftQuantity(variantId, quantity) {
                    fetch("/cart/update.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ updates: { [variantId]: quantity } }),
                    })
                        .then(response => response.json())
                        .then(data => {
                            console.log("Updated gift quantity:", data);
                            updateCartDrawer();
                        })
                        .catch(error => console.error("Error updating gift quantity:", error));
                }
            
                function removeGiftFromCart(variantId) {
                    fetch("/cart/update.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ updates: { [variantId]: 0 } }),
                    })
                        .then(response => response.json())
                        .then(data => {
                            console.log("Removed gift from cart:", data);
                            updateCartDrawer();
                        })
                        .catch(error => console.error("Error removing gift from cart:", error));
                }
            
                function updateCartDrawer() {
                    fetch("/cart")
                        .then(response => response.text())
                        .then(html => {
                            let parser = new DOMParser();
                            let doc = parser.parseFromString(html, "text/html");
                            let newCartForm = doc.querySelector("#CartDrawer-Form");
                            let currentCartForm = document.querySelector("#CartDrawer-Form");
            
                            if (newCartForm && currentCartForm) {
                                console.log("Cart updated in progress bar");
                                currentCartForm.innerHTML = newCartForm.innerHTML;
                            }
                        })
                        .catch(error => console.error("Error updating cart drawer:", error));
                }
            
                fetch("/cart.js")
                    .then(response => response.json())
                    .then(cart => {
                        const subtotal = cart.total_price / 100;
                        const mediumGiftTarget = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
                        const premiumTarget = parseFloat(document.querySelector(".target_amount")?.textContent) || 100;
            
                        updateProgressBar(subtotal);
                        updateShippingMessage(subtotal);
                        handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget);
                    })
                    .catch(error => console.error("Error fetching cart:", error));
            }

  
  // end here

  $spinner.show();
  $btn_txt_upsell.hide();

  let formData = {
    items: [
      {
        id: ID,
        quantity: 1,
      },
    ],
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status !== "error") {
        refreshCartDrawer($spinner);
        updateCartDrawer();

        // Fetch updated cart data before updating progress bar
        fetch("/cart.js")
          .then(response => response.json())
          .then(cart => {
            const subtotal = cart.total_price / 100; // Convert cents to currency
            setTimeout(function() {
              const mediumGiftTarget = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
              const premiumTarget = parseFloat(document.querySelector(".target_amount")?.textContent) || 100;
              handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget);
              updateProgressBar(subtotal);
              updateShippingMessage(subtotal);
              console.log("upsell updated cart with new subtotal:", subtotal);
           }, 2000);
          })
          .catch(error => console.error("Error fetching updated cart:", error));

        setTimeout(function() {
          // Start cart timer if applicable
          let cartTimerElement = document.getElementById("cart-timer");
          let timerElement = document.getElementById("timer");
          if (!cartTimerElement || !timerElement) return;

          let defaultTime =
            parseInt(cartTimerElement.getAttribute("data-expiry-time")) * 60 || 600;
          let time = localStorage.getItem("cartTimer")
            ? parseInt(localStorage.getItem("cartTimer"))
            : defaultTime;

          function updateTimer() {
            if (time <= 0) {
              localStorage.removeItem("cartTimer");
              cartTimerElement.style.display = "none";
              return;
            }
            let minutes = Math.floor(time / 60);
            let seconds = time % 60;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            timerElement.textContent = `${minutes}:${seconds}`;
            time--;
            localStorage.setItem("cartTimer", time);
            setTimeout(updateTimer, 1000);
          }
          updateTimer();
          console.log("upsell timer updated");
        }, 2000);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      $spinner.hide();
    });

});

// custom js by mandasa
$(document).on('click', '.upcart-upsells-button', function(event) {
    event.preventDefault(); 
    // Using data attribute for var_id
    var ID = $(this).attr("data-var-id"); 
    var $button_upsell = $(this); 
    var $btn_check1 = $button_upsell.find('.styles_ToggleSwitch__circle__JNYJJ'); 
    var $btn_check2 = $button_upsell.find('.styles_ToggleSwitch__checkMark__S5hoe'); 
    var $topParent = $button_upsell.closest('.Stack__item');
    var productId = $topParent.attr('product_id');

      const giftids = document.querySelector(".id_here");
      const mediumGiftVariantId = parseInt(giftids?.getAttribute('data_id'), 10) || null;
      const targetGiftVariantId = parseInt(giftids?.getAttribute('data_gift'), 10) || null;
      const main_progress = document.querySelector('.shipping-bar-container');
      var selected_id = 48858005733723;
      if (main_progress){
        console.log("get main_progress");
    //     function updateProgressBar(subtotal) {
    //           let freeShipElement = document.querySelector(".target-free-ship");
    //           let mediumGiftElement = document.querySelector(".medium-gift");
    //           let premiumTargetElement = document.querySelector(".target_amount");
          
    //           let freeShip = freeShipElement ? parseFloat(freeShipElement.textContent) || 0 : 0;
    //           let mediumGift = mediumGiftElement ? parseFloat(mediumGiftElement.textContent) || 0 : 0;
    //           let premiumtarget = premiumTargetElement ? parseFloat(premiumTargetElement.textContent) || 100 : 100;
          
    //           let highestTarget = Math.max(freeShip, mediumGift, premiumtarget);
          
    //           let progressBar = document.getElementById("progress-bar");
    //           if (progressBar) {
    //               let progressPercentage = Math.min((subtotal / highestTarget) * 100, 100);
    //               requestAnimationFrame(() => {
    //                   progressBar.style.transition = "width 1.6s ease-out";
    //                   progressBar.style.width = progressPercentage + "%";
    //               });
    //           }

    //         updateStep(".step1", ".new_hide1", freeShip, subtotal);
    //         updateStep(".step2", ".new_hide2", mediumGift, subtotal);
    //         updateStep(".step3", ".new_hide3", premiumtarget, subtotal);
            
    //       }

    //     function updateStep(stepSelector, hideSelector, target, subtotal) {
    //       setTimeout(() => {
    //         let step = document.querySelector(stepSelector);
    //         let hideElement = document.querySelector(hideSelector);
    //         if (step && hideElement) {
    //           if (subtotal >= target) {
    //             step.classList.add("hide-main");
    //             hideElement.classList.add("active");
    //             hideElement.style.display = "block";
    //           } else {
    //             step.classList.remove("hide-main");
    //             hideElement.classList.remove("active");
    //             hideElement.style.display = "none";
    //           }
    //         }
    //       }, 1000);
    //     }
        
    //     function updateShippingMessage(subtotal) {
    //     let freeShipTarget = parseFloat(document.querySelector(".target-free-ship")?.textContent) || 0;
    //     let mediumGiftTarget = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
    //     let targetAmount = parseFloat(document.querySelector(".target_amount")?.textContent) || 100;
    
    //     let shippingMessage = document.getElementById("shipping-message");
    
    //     if (shippingMessage) {
    //         let spans = shippingMessage.querySelectorAll("span:not(.amount-placeholder)");
    //         let amounts = shippingMessage.querySelectorAll(".amount-placeholder");
    
    //         spans.forEach(span => span.style.display = "none");
    
    //         if (subtotal < freeShipTarget && spans[0] && amounts[0]) {
    //             let remaining = (freeShipTarget - subtotal).toFixed(2);
    //             spans[0].style.display = "block";
    //             amounts[0].textContent = remaining;
    //         } else if (subtotal < mediumGiftTarget && spans[1] && amounts[1]) {
    //             let remaining = (mediumGiftTarget - subtotal).toFixed(2);
    //             spans[1].style.display = "block";
    //             amounts[1].textContent = remaining;
    //         } else if (subtotal < targetAmount && spans[2] && amounts[2]) {
    //             let remaining = (targetAmount - subtotal).toFixed(2);
    //             spans[2].style.display = "block";
    //             amounts[2].textContent = remaining;
    //         } else if (spans[3]) {
    //             spans[3].style.display = "block";
    //         }
    //     }
    // }

    //     function handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget) {
    //         fetch("/cart.js")
    //             .then(response => response.json())
    //             .then(cart => {
    //                 const cartItems = cart.items || [];
    //                 const hasMediumGift = cartItems.some(item => item.id === mediumGiftVariantId);
    //                 const hasTargetGift = cartItems.some(item => item.id === targetGiftVariantId);
        
    //                 console.log("Cart Items:", cartItems);
    //                 console.log("Subtotal:", subtotal, "Medium Gift Target:", mediumGiftTarget, "Premium Target:", premiumTarget);
    //                 console.log("Has Medium Gift:", hasMediumGift, "Has Target Gift:", hasTargetGift);
        
    //                 if (subtotal >= mediumGiftTarget && !hasMediumGift) {
    //                     console.log("Adding Medium Gift...");
    //                     addGiftToCart(mediumGiftVariantId);
    //                 } else if (subtotal < mediumGiftTarget && hasMediumGift) {
    //                     console.log("Removing Medium Gift...");
    //                     removeGiftFromCart(mediumGiftVariantId);
    //                 }
        
    //                 if (subtotal >= premiumTarget && !hasTargetGift) {
    //                     console.log("Adding Premium Gift...");
    //                     addGiftToCart(targetGiftVariantId);
    //                 } else if (subtotal < premiumTarget && hasTargetGift) {
    //                     console.log("Removing Premium Gift...");
    //                     removeGiftFromCart(targetGiftVariantId);
    //                 }
    //             })
    //             .catch(error => console.error("Error fetching cart:", error));
    //     }

        function updateProgressBar(subtotal) {
                      let freeShip = parseFloat(document.querySelector(".target-free-ship")?.textContent) || 0;
                      let mediumGift = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
                      let premiumTarget = parseFloat(document.querySelector(".target_amount")?.textContent) || 100;
                      let highestTarget = Math.max(freeShip, mediumGift, premiumTarget);
              
                      let progressBar = document.getElementById("progress-bar");
                      if (progressBar) {
                          let progressPercentage = Math.min((subtotal / highestTarget) * 100, 100);
                          requestAnimationFrame(() => {
                              progressBar.style.transition = "width 1.6s ease-out";
                              progressBar.style.width = progressPercentage + "%";
                          });
                      }
              
                      updateStep(".step1", ".new_hide1", freeShip, subtotal);
                      updateStep(".step2", ".new_hide2", mediumGift, subtotal);
                      updateStep(".step3", ".new_hide3", premiumTarget, subtotal);
                  }
              
        function updateStep(stepSelector, hideSelector, target, subtotal) {
            setTimeout(() => {
                let step = document.querySelector(stepSelector);
                let hideElement = document.querySelector(hideSelector);
                if (step && hideElement) {
                    if (subtotal >= target) {
                        step.classList.add("hide-main");
                        hideElement.classList.add("active");
                        hideElement.style.display = "block";
                    } else {
                        step.classList.remove("hide-main");
                        hideElement.classList.remove("active");
                        hideElement.style.display = "none";
                    }
                }
            }, 1000);
        }
    
        function updateShippingMessage(subtotal) {
            let freeShipTarget = parseFloat(document.querySelector(".target-free-ship")?.textContent) || 0;
            let mediumGiftTarget = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
            let targetAmount = parseFloat(document.querySelector(".target_amount")?.textContent) || 0;
    
            let shippingMessage = document.getElementById("shipping-message");
    
            if (shippingMessage) {
                let spans = shippingMessage.querySelectorAll("span:not(.amount-placeholder)");
                let amounts = shippingMessage.querySelectorAll(".amount-placeholder");
    
                spans.forEach(span => span.style.display = "none");
    
              // Convert values to numbers or null if empty
            let freeShipTargetNum = freeShipTarget ? Number(freeShipTarget) : null;
            let mediumGiftTargetNum = mediumGiftTarget ? Number(mediumGiftTarget) : null;
            let targetAmountNum = targetAmount ? Number(targetAmount) : null;
            
            console.log("All targets available:", freeShipTargetNum !== null && mediumGiftTargetNum !== null && targetAmountNum !== null);
            console.log("Medium gift missing:", mediumGiftTargetNum === null && targetAmountNum !== null);
            console.log("Target amount missing:", targetAmountNum === null && mediumGiftTargetNum !== null);
                      console.log("targetAmountNum" , targetAmountNum);
            
            if (freeShipTargetNum !== null && mediumGiftTargetNum !== null && targetAmountNum !== null) {
                if (subtotal < freeShipTargetNum && spans[0] && amounts[0]) {
                    let remaining = (freeShipTargetNum - subtotal).toFixed(2);
                    spans[0].style.display = "block";
                    amounts[0].textContent = remaining;
                } else if (subtotal < mediumGiftTargetNum && spans[1] && amounts[1]) {
                    let remaining = (mediumGiftTargetNum - subtotal).toFixed(2);
                    spans[1].style.display = "block";
                    amounts[1].textContent = remaining;
                } else if (subtotal < targetAmountNum && spans[2] && amounts[2]) {
                    let remaining = (targetAmountNum - subtotal).toFixed(2);
                    spans[2].style.display = "block";
                    amounts[2].textContent = remaining;
                } else if (spans[3]) {
                    spans[3].style.display = "block";
                }
            } else if (mediumGiftTargetNum === null && targetAmountNum !== null) {
              if (subtotal < freeShipTargetNum && spans[0] && amounts[0]) {
                console.log("get it");
                    let remaining = (freeShipTargetNum - subtotal).toFixed(2);
                    spans[0].style.display = "block";
                    amounts[0].textContent = remaining;
                } else if (subtotal < targetAmountNum && spans[1] && amounts[1]) {
                    let remaining = (targetAmountNum - subtotal).toFixed(2);
                    spans[1].style.display = "block";
                    amounts[1].textContent = remaining;
                } else if (spans[2]) {
                    spans[2].style.display = "block";
                }
            } else if (targetAmountNum === null &&  mediumGiftTargetNum !== null) {
               if (subtotal < freeShipTargetNum && spans[0] && amounts[0]) {
                    let remaining = (freeShipTargetNum - subtotal).toFixed(2);
                    spans[0].style.display = "block";
                    amounts[0].textContent = remaining;
                } else if (subtotal < mediumGiftTargetNum && spans[1] && amounts[1]) {
                    let remaining = (mediumGiftTargetNum - subtotal).toFixed(2);
                    spans[1].style.display = "block";
                    amounts[1].textContent = remaining;
                } else if (spans[2]) {
                    spans[2].style.display = "block";
                }
            }
    
    
            }
        }
    
        function handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget) {
            fetch("/cart.js")
                .then(response => response.json())
                .then(cart => {
                    const cartItems = cart.items || [];
                    const mediumGiftItem = cartItems.find(item => item.id === mediumGiftVariantId);
                    const targetGiftItem = cartItems.find(item => item.id === targetGiftVariantId);
        
                    if (subtotal >= mediumGiftTarget) {
                        if (!mediumGiftItem) {
                            addGiftToCart(mediumGiftVariantId);
                        } else if (mediumGiftItem.quantity !== 1) {
                            updateGiftQuantity(mediumGiftVariantId, 1);
                        }
                    } else if (mediumGiftItem) {
                        removeGiftFromCart(mediumGiftVariantId);
                    }
        
                    if (subtotal >= premiumTarget) {
                        if (!targetGiftItem) {
                            addGiftToCart(targetGiftVariantId);
                        } else if (targetGiftItem.quantity !== 1) {
                            updateGiftQuantity(targetGiftVariantId, 1);
                        }
                    } else if (targetGiftItem) {
                        removeGiftFromCart(targetGiftVariantId);
                    }
                })
                .catch(error => console.error("Error fetching cart:", error));
        }

        function updateGiftQuantity(variantId, quantity) {
                    fetch("/cart/update.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ updates: { [variantId]: quantity } }),
                    })
                        .then(response => response.json())
                        .then(data => {
                            console.log("Updated gift quantity:", data);
                            updateCartDrawer();
                        })
                        .catch(error => console.error("Error updating gift quantity:", error));
                }
        
        function addGiftToCart(variantId) {
            console.log(`Attempting to add variant ${variantId} to cart.`);
            fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: variantId, quantity: 1 }),
            })
                .then(response => response.json())
                .then(data => {
                    console.log("Added to cart:", data);
                  const subtotal = data.total_price / 100;
                    updateCartDrawer();
                    handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget);
                  updateProgressBar(subtotal);
                  
                })
                .catch(error => console.error("Error adding gift to cart:", error));
        }
        
        function removeGiftFromCart(variantId) {
          console.log(`Attempting to remove variant ${variantId} from cart.`);
          
          fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ updates: { [variantId]: 0 } }) // Correct way to update cart quantity
          })
          .then(response => response.json())
          .then(data => {
              console.log("Removed from cart:", data);
              updateCartDrawer();
      
              const subtotal = data.total_price / 100;
              let freeShipElement = document.querySelector(".target-free-ship");
              let mediumGiftElement = document.querySelector(".medium-gift");
              let premiumTargetElement = document.querySelector(".target_amount");
      
              let freeShip = freeShipElement ? parseFloat(freeShipElement.textContent) || 0 : 0;
              let mediumGift = mediumGiftElement ? parseFloat(mediumGiftElement.textContent) || 0 : 0;
              let premiumtarget = premiumTargetElement ? parseFloat(premiumTargetElement.textContent) || 100 : 100;
      
              updateStep(".step1", ".new_hide1", freeShip, subtotal);
              updateStep(".step2", ".new_hide2", mediumGift, subtotal);
              updateStep(".step3", ".new_hide3", premiumtarget, subtotal);
          })
          .catch(error => console.error("Error removing gift from cart:", error));
      }
        
        function updateCartDrawer() {
              fetch("/cart")
                .then((response) => response.text())
                .then((html) => {
                  let parser = new DOMParser();
                  let doc = parser.parseFromString(html, "text/html");
                  let newCartForm = doc.querySelector(".cart__ctas");
                  let currentCartForm = document.querySelector(".cart__ctas");
                  let formitem = document.querySelector("#CartDrawer-Form");
                  let newformitem = doc.querySelector("#CartDrawer-Form");
          
                  if (newCartForm && currentCartForm && formitem && newformitem) {
                    console.log("cart items updated in progress bar");
                    currentCartForm.innerHTML = newCartForm.innerHTML;
                    formitem.innerHTML = newformitem.innerHTML;

                      // Start cart timer if applicable
                        let cartTimerElement = document.getElementById("cart-timer");
                        let timerElement = document.getElementById("timer");
                        if (!cartTimerElement || !timerElement) return;
              
                        let defaultTime =
                          parseInt(cartTimerElement.getAttribute("data-expiry-time")) * 60 || 600;
                        let time = localStorage.getItem("cartTimer")
                          ? parseInt(localStorage.getItem("cartTimer"))
                          : defaultTime;
              
                        function updateTimer() {
                          if (time <= 0) {
                            localStorage.removeItem("cartTimer");
                            cartTimerElement.style.display = "none";
                            return;
                          }
                          let minutes = Math.floor(time / 60);
                          let seconds = time % 60;
                          seconds = seconds < 10 ? "0" + seconds : seconds;
                          timerElement.textContent = `${minutes}:${seconds}`;
                          time--;
                          localStorage.setItem("cartTimer", time);
                          setTimeout(updateTimer, 1000);
                        }
                        updateTimer();
                  }
                })
                .catch((error) => console.error("Error updating cart drawer:", error));
            }
      }

    // Access toggle elements
    const toggleSwitch_mt = $button_upsell.find('.styles_ToggleSwitch__JFeYW');
    const toggleSwitchCircle_mt = $button_upsell.find('.styles_ToggleSwitch__circle__JNYJJ');

    if (toggleSwitch_mt && toggleSwitchCircle_mt) {
        toggleSwitch_mt.toggleClass('styles_ToggleSwitch--active__jLEhN');
        toggleSwitchCircle_mt.toggleClass('styles_ToggleSwitch__circle--active__ZRSCR');
  
        let formData = {
          'items': [{
              'id': ID,
              'quantity': 1
          }]
        };

        const isActive_mt = toggleSwitch_mt.hasClass('styles_ToggleSwitch--active__jLEhN');

        if (isActive_mt) {
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => response.json())
            .then(data => {
                if (!data.status) {
                    updateCartDrawer();
                }
              return fetch(window.Shopify.routes.root + 'cart.js');
            })
              .then(response => response.json())
              .then(cart => {
                  const subtotal = cart.total_price / 100; // Convert from cents to currency
                  const mediumGiftTarget = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
                  const premiumTarget = parseFloat(document.querySelector(".target_amount")?.textContent) || 100;
          
                  updateProgressBar(subtotal);
                  updateShippingMessage(subtotal);
                  handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget);
          
                  startCartTimer();
                  
                  console.log("Fetched and updated steps");
              })
            .catch((error) => {
                console.error('Error:', error);
            });
        } else {
            fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: ID, quantity: 0 })
            })
            .then(response => response.json())
            .then(data => {
              console.log("Product removed:", data);
              updateCartDrawer();
              return fetch(window.Shopify.routes.root + 'cart.js');
            })
            .then(response => response.json())
            .then(cart => {
                  const subtotal = cart.total_price / 100; // Convert from cents to currency
                  const mediumGiftTarget = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
                  const premiumTarget = parseFloat(document.querySelector(".target_amount")?.textContent) || 100;
          
                  updateProgressBar(subtotal);
                  updateShippingMessage(subtotal);
                  handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget);
          
                  startCartTimer();
                  
                  console.log("Fetched and updated steps");
              })
            .catch(error => {
                console.error('Error removing product:', error);
            });
        }
    }
});

function refreshCartDrawer($spinner_upsell) {
  $.ajax({
    url: window.Shopify.routes.root + 'cart',
    method: 'GET',
    success: function(response) {
      $('.cart-drawer').html($(response).find('.cart-drawer').html());
      // $spinner_upsell.hide();
      if ($('#up-upsell-carousel span').length === 0) {
        $('#up-upsell-carousel').hide();
      }
      // $('cart-drawer-items').scrollTop($('cart-drawer-items')[0].scrollHeight);
    },
    error: function() {
      $spinner_upsell.hide();
    }
  });
}


// free ship protection toggle added and removed from here
document.addEventListener('DOMContentLoaded', function() {
    window.shippingCart = function() {
      // alert('click');
      const toggleContainer = document.querySelector('.upcart-addons-toggle'); 
      const toggleSwitch = toggleContainer.querySelector('.styles_ToggleSwitch__jLEhN');
      const toggleSwitchCircle = toggleContainer.querySelector('.styles_ToggleSwitch__ZRSCR');
      const checkoutBtn = document.querySelector('.checkout_btn');
      const productId = document.querySelector('.upcart-addons').getAttribute('product_id');

       const giftids = document.querySelector(".id_here");
      const mediumGiftVariantId = parseInt(giftids?.getAttribute('data_id'), 10) || null;
      const targetGiftVariantId = parseInt(giftids?.getAttribute('data_gift'), 10) || null;
      const main_progress = document.querySelector('.shipping-bar-container');
      var selected_id = 48858005733723;
      if (main_progress){
            console.log("get main_progress");

            function updateProgressBar(subtotal) {
                      let freeShip = parseFloat(document.querySelector(".target-free-ship")?.textContent) || 0;
                      let mediumGift = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
                      let premiumTarget = parseFloat(document.querySelector(".target_amount")?.textContent) || 100;
                      let highestTarget = Math.max(freeShip, mediumGift, premiumTarget);
              
                      let progressBar = document.getElementById("progress-bar");
                      if (progressBar) {
                          let progressPercentage = Math.min((subtotal / highestTarget) * 100, 100);
                          requestAnimationFrame(() => {
                              progressBar.style.transition = "width 1.6s ease-out";
                              progressBar.style.width = progressPercentage + "%";
                          });
                      }
              
                      updateStep(".step1", ".new_hide1", freeShip, subtotal);
                      updateStep(".step2", ".new_hide2", mediumGift, subtotal);
                      updateStep(".step3", ".new_hide3", premiumTarget, subtotal);
                  }
              
            function updateStep(stepSelector, hideSelector, target, subtotal) {
                setTimeout(() => {
                    let step = document.querySelector(stepSelector);
                    let hideElement = document.querySelector(hideSelector);
                    if (step && hideElement) {
                        if (subtotal >= target) {
                            step.classList.add("hide-main");
                            hideElement.classList.add("active");
                            hideElement.style.display = "block";
                        } else {
                            step.classList.remove("hide-main");
                            hideElement.classList.remove("active");
                            hideElement.style.display = "none";
                        }
                    }
                }, 1000);
            }
        
            function updateShippingMessage(subtotal) {
                let freeShipTarget = parseFloat(document.querySelector(".target-free-ship")?.textContent) || 0;
                let mediumGiftTarget = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
                let targetAmount = parseFloat(document.querySelector(".target_amount")?.textContent) || 0;
        
                let shippingMessage = document.getElementById("shipping-message");
        
                if (shippingMessage) {
                    let spans = shippingMessage.querySelectorAll("span:not(.amount-placeholder)");
                    let amounts = shippingMessage.querySelectorAll(".amount-placeholder");
        
                    spans.forEach(span => span.style.display = "none");
        
                  // Convert values to numbers or null if empty
                let freeShipTargetNum = freeShipTarget ? Number(freeShipTarget) : null;
                let mediumGiftTargetNum = mediumGiftTarget ? Number(mediumGiftTarget) : null;
                let targetAmountNum = targetAmount ? Number(targetAmount) : null;
                
                console.log("All targets available:", freeShipTargetNum !== null && mediumGiftTargetNum !== null && targetAmountNum !== null);
                console.log("Medium gift missing:", mediumGiftTargetNum === null && targetAmountNum !== null);
                console.log("Target amount missing:", targetAmountNum === null && mediumGiftTargetNum !== null);
                          console.log("targetAmountNum" , targetAmountNum);
                
                if (freeShipTargetNum !== null && mediumGiftTargetNum !== null && targetAmountNum !== null) {
                    if (subtotal < freeShipTargetNum && spans[0] && amounts[0]) {
                        let remaining = (freeShipTargetNum - subtotal).toFixed(2);
                        spans[0].style.display = "block";
                        amounts[0].textContent = remaining;
                    } else if (subtotal < mediumGiftTargetNum && spans[1] && amounts[1]) {
                        let remaining = (mediumGiftTargetNum - subtotal).toFixed(2);
                        spans[1].style.display = "block";
                        amounts[1].textContent = remaining;
                    } else if (subtotal < targetAmountNum && spans[2] && amounts[2]) {
                        let remaining = (targetAmountNum - subtotal).toFixed(2);
                        spans[2].style.display = "block";
                        amounts[2].textContent = remaining;
                    } else if (spans[3]) {
                        spans[3].style.display = "block";
                    }
                } else if (mediumGiftTargetNum === null && targetAmountNum !== null) {
                  if (subtotal < freeShipTargetNum && spans[0] && amounts[0]) {
                    console.log("get it");
                        let remaining = (freeShipTargetNum - subtotal).toFixed(2);
                        spans[0].style.display = "block";
                        amounts[0].textContent = remaining;
                    } else if (subtotal < targetAmountNum && spans[1] && amounts[1]) {
                        let remaining = (targetAmountNum - subtotal).toFixed(2);
                        spans[1].style.display = "block";
                        amounts[1].textContent = remaining;
                    } else if (spans[2]) {
                        spans[2].style.display = "block";
                    }
                } else if (targetAmountNum === null &&  mediumGiftTargetNum !== null) {
                   if (subtotal < freeShipTargetNum && spans[0] && amounts[0]) {
                        let remaining = (freeShipTargetNum - subtotal).toFixed(2);
                        spans[0].style.display = "block";
                        amounts[0].textContent = remaining;
                    } else if (subtotal < mediumGiftTargetNum && spans[1] && amounts[1]) {
                        let remaining = (mediumGiftTargetNum - subtotal).toFixed(2);
                        spans[1].style.display = "block";
                        amounts[1].textContent = remaining;
                    } else if (spans[2]) {
                        spans[2].style.display = "block";
                    }
                }
        
        
                }
            }

            function handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget) {
                fetch("/cart.js")
                    .then(response => response.json())
                    .then(cart => {
                        const cartItems = cart.items || [];
                        const mediumGiftItem = cartItems.find(item => item.id === mediumGiftVariantId);
                        const targetGiftItem = cartItems.find(item => item.id === targetGiftVariantId);

                      setTimeout(function() {
                        if (subtotal >= mediumGiftTarget) {
                            if (!mediumGiftItem) {
                                addGiftToCart(mediumGiftVariantId);
                            } else if (mediumGiftItem.quantity !== 1) {
                                updateGiftQuantity(mediumGiftVariantId, 1);
                            }
                        } else if (mediumGiftItem) {
                            removeGiftFromCart(mediumGiftVariantId);
                        }
                        console.log("med inside setimeout");
                      }, 1000);

                      setTimeout(function() {
                        if (subtotal >= premiumTarget) {
                            if (!targetGiftItem) {
                                addGiftToCart(targetGiftVariantId);
                            } else if (targetGiftItem.quantity !== 1) {
                                updateGiftQuantity(targetGiftVariantId, 1);
                            }
                        } else if (targetGiftItem) {
                            removeGiftFromCart(targetGiftVariantId);
                        }
                        console.log("pre inside setimeout");
                       }, 2300); 
                      
                    })
                    .catch(error => console.error("Error fetching cart:", error));
            }

            function updateGiftQuantity(variantId, quantity) {
                    fetch("/cart/update.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ updates: { [variantId]: quantity } }),
                    })
                        .then(response => response.json())
                        .then(data => {
                            console.log("Updated gift quantity:", data);
                            updateCartDrawer();
                        })
                        .catch(error => console.error("Error updating gift quantity:", error));
                }
            
            function addGiftToCart(variantId) {
                console.log(`Attempting to add variant ${variantId} to cart.`);
                fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: variantId, quantity: 1 }),
                })
                    .then(response => response.json())
                    .then(data => {
                        console.log("Added to cart:", data);
                      const subtotal = data.total_price / 100;
                        updateCartDrawer();
                        handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget);
                      updateProgressBar(subtotal);
                      
                    })
                    .catch(error => console.error("Error adding gift to cart:", error));
            }
            
            function removeGiftFromCart(variantId) {
              console.log(`Attempting to remove variant ${variantId} from cart.`);
              
              fetch("/cart/update.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ updates: { [variantId]: 0 } }) // Correct way to update cart quantity
              })
              .then(response => response.json())
              .then(data => {
                  console.log("Removed from cart:", data);
                  updateCartDrawer();
          
                  const subtotal = data.total_price / 100;
                  let freeShipElement = document.querySelector(".target-free-ship");
                  let mediumGiftElement = document.querySelector(".medium-gift");
                  let premiumTargetElement = document.querySelector(".target_amount");
          
                  let freeShip = freeShipElement ? parseFloat(freeShipElement.textContent) || 0 : 0;
                  let mediumGift = mediumGiftElement ? parseFloat(mediumGiftElement.textContent) || 0 : 0;
                  let premiumtarget = premiumTargetElement ? parseFloat(premiumTargetElement.textContent) || 100 : 100;
          
                  updateStep(".step1", ".new_hide1", freeShip, subtotal);
                  updateStep(".step2", ".new_hide2", mediumGift, subtotal);
                  updateStep(".step3", ".new_hide3", premiumtarget, subtotal);
              })
              .catch(error => console.error("Error removing gift from cart:", error));
          }
            
            function updateCartDrawer() {
              fetch("/cart")
                .then((response) => response.text())
                .then((html) => {
                  let parser = new DOMParser();
                  let doc = parser.parseFromString(html, "text/html");
                  let newCartForm = doc.querySelector(".cart__ctas");
                  let currentCartForm = document.querySelector(".cart__ctas");
                  let formitem = document.querySelector("#CartDrawer-Form");
                  let newformitem = doc.querySelector("#CartDrawer-Form");
          
                  if (newCartForm && currentCartForm && formitem && newformitem) {
                    console.log("cart items updated in progress bar");
                    currentCartForm.innerHTML = newCartForm.innerHTML;
                    formitem.innerHTML = newformitem.innerHTML;

                      // Start cart timer if applicable
                        let cartTimerElement = document.getElementById("cart-timer");
                        let timerElement = document.getElementById("timer");
                        if (!cartTimerElement || !timerElement) return;
              
                        let defaultTime =
                          parseInt(cartTimerElement.getAttribute("data-expiry-time")) * 60 || 600;
                        let time = localStorage.getItem("cartTimer")
                          ? parseInt(localStorage.getItem("cartTimer"))
                          : defaultTime;
              
                        function updateTimer() {
                          if (time <= 0) {
                            localStorage.removeItem("cartTimer");
                            cartTimerElement.style.display = "none";
                            return;
                          }
                          let minutes = Math.floor(time / 60);
                          let seconds = time % 60;
                          seconds = seconds < 10 ? "0" + seconds : seconds;
                          timerElement.textContent = `${minutes}:${seconds}`;
                          time--;
                          localStorage.setItem("cartTimer", time);
                          setTimeout(updateTimer, 1000);
                        }
                        updateTimer();
                  }
                })
                .catch((error) => console.error("Error updating cart drawer:", error));
            }
            }

      if (toggleSwitch && toggleSwitchCircle && checkoutBtn) {
        toggleSwitch.classList.toggle('styles_ToggleSwitch--active__jLEhN');
        toggleSwitchCircle.classList.toggle('styles_ToggleSwitch__circle--active__ZRSCR');

        const isActive = toggleSwitch.classList.contains('styles_ToggleSwitch--active__jLEhN');
        if (isActive) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(productId), quantity: 1 }] })
    })
    .then(response => response.json())
    .then(data => {
        updateCartDrawer();
        console.log("Product added from here", data);
        return fetch(window.Shopify.routes.root + 'cart.js'); // Fetch updated cart
    })
    .then(response => response.json())
    .then(cart => {
        const subtotal = cart.total_price / 100; // Convert from cents to currency
        const mediumGiftTarget = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
        const premiumTarget = parseFloat(document.querySelector(".target_amount")?.textContent) || 100;

        updateProgressBar(subtotal);
        updateShippingMessage(subtotal);
        handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget);

        startCartTimer();
        
        console.log("Fetched and updated steps");
    })
    .catch(error => console.error("Error adding product or fetching cart:", error));
} else {
    fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: productId, quantity: 0 })
    })
    .then(response => response.json())
    .then(data => {
        updateCartDrawer();
        console.log("Product removed from here:", data);
        return fetch(window.Shopify.routes.root + 'cart.js'); // Fetch updated cart
    })
    .then(response => response.json())
    .then(cart => {
        const subtotal = cart.total_price / 100; // Convert from cents to currency
        const mediumGiftTarget = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
        const premiumTarget = parseFloat(document.querySelector(".target_amount")?.textContent) || 100;

        updateProgressBar(subtotal);
        updateShippingMessage(subtotal);
        handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget);

        startCartTimer();
        
        console.log("Fetched and updated steps");
    })
    .catch(error => console.error("Error removing product or fetching cart:", error));
}

// Cart Timer Function
function startCartTimer() {
    let cartTimerElement = document.getElementById("cart-timer");
    let timerElement = document.getElementById("timer");
    if (!cartTimerElement || !timerElement) return;

    let defaultTime = parseInt(cartTimerElement.getAttribute("data-expiry-time")) * 60 || 600;
    let time = localStorage.getItem("cartTimer") ? parseInt(localStorage.getItem("cartTimer")) : defaultTime;

    function updateTimer() {
        if (time <= 0) {
            localStorage.removeItem("cartTimer");
            cartTimerElement.style.display = "none";
            return;
        }
        let minutes = Math.floor(time / 60);
        let seconds = time % 60;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        timerElement.textContent = `${minutes}:${seconds}`;
        time--;
        localStorage.setItem("cartTimer", time);
        setTimeout(updateTimer, 1000);
    }
    updateTimer();
}

      }
    }
  });